'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _events = require('./events');

var Events = _interopRequireWildcard(_events);

var _StorageAdapter = require('./StorageAdapter');

var _StorageAdapter2 = _interopRequireDefault(_StorageAdapter);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var APP_TYPE = 'app';

var validName = function validName(nameString) {
  return typeof nameString === 'string' && nameString.length > 0;
};

var validNameValuePair = function validNameValuePair(nameAndValue) {
  var isValid = false;

  if (nameAndValue instanceof Array && nameAndValue.length >= 2) {
    var _nameAndValue = (0, _slicedToArray3.default)(nameAndValue, 1),
        name = _nameAndValue[0];

    isValid = validName(name);
  }

  return isValid;
};

/**
 * @private
 * @ignore
 * @param batch
 * @return {Error|null}
 */
var validateNameValuePairsList = function validateNameValuePairsList(batch) {
  if (!batch instanceof Array || batch.length === 0) {
    return new Error('In batch mode, the first parameter must be a non-empty Array');
  }

  var invalidPairs = batch.filter(function (nameAndValue) {
    return !validNameValuePair(nameAndValue);
  });
  if (invalidPairs.length) {
    return new Error('Bad method call: some of the name and value pairs were invalid. A name-value pair should have a non empty name and a value');
  }

  return null;
};

/**
 * @class
 */

var StorageApiFacade = function () {
  /**
   * @param {AppEventEmitter} outgoingDispatcher the outgoing event dispatcher
   * @param {AppEventEmitter} internalDispatcher the interval event dispatcher
   * @param {StorageAdapter} storageAdapter a storage adapter
   * @param {String} instanceId the id of this application's instance
   * @param {String} appId the id of this application
   * @param {String} contextEntityType the type of the context entity
   * @param {String} contextEntityId the id of the context entity
   * @param {...*} [other]
   */
  function StorageApiFacade(outgoingDispatcher, internalDispatcher, storageAdapter, _ref) {
    var instanceId = _ref.instanceId,
        appId = _ref.appId,
        contextEntityType = _ref.contextEntityType,
        contextEntityId = _ref.contextEntityId,
        other = (0, _objectWithoutProperties3.default)(_ref, ['instanceId', 'appId', 'contextEntityType', 'contextEntityId']);
    (0, _classCallCheck3.default)(this, StorageApiFacade);

    if (!storageAdapter instanceof _StorageAdapter2.default) {
      throw new Error('param storageAdapter must be an instance of StorageAdapter');
    }
    this.props = (0, _extends3.default)({ outgoingDispatcher: outgoingDispatcher, internalDispatcher: internalDispatcher, storageAdapter: storageAdapter, instanceId: instanceId, contextEntityType: contextEntityType, contextEntityId: contextEntityId, appId: appId }, other);
  }

  /**
   * Stores a value or a list of values. This method supports the following signatures:
   *
   * - Single item mode
   * ```
   *  setStorage(name:String, value:*, entityId:String): Promise<*,Error>
   * ```
   *
   * - Batch mode
   * ```
   *  setStorage(batch:Array<{name:String, value:*}>, entityId:String): Promise<Array<{name:String, value:*}>,Error>
   * ```
   *
   * See the list of parameters for a description of each one
   *
   * @public
   * @method
   *
   * @param {...*} args
   * @param {string} [args.name] the name under which to store the value
   * @param {string} [args.value] the value to be stored. Will be `JSON serialized`
   * @param {Array<{name:String, value:*}>} [args.batch] a list of name-value pairs for batch processing
   * @param {string} args.entityId the id of the entity to link the values to
   *
   * @return {Promise<Array<{name:String, value:*}>|String,Error>} the list of values which were not saved in batch mode or the saved value in single mode
   */


  (0, _createClass3.default)(StorageApiFacade, [{
    key: 'setStorage',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var _this = this;

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        var storageAdapter, name, value, entityId, batch, _entityId, batchError;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                storageAdapter = this.props.storageAdapter;

                if (!(args.length === 3)) {
                  _context.next = 6;
                  break;
                }

                //
                name = args[0], value = args[1], entityId = args[2];

                if (validName(name)) {
                  _context.next = 5;
                  break;
                }

                throw new Error('Bad method call: name parameter must be a non empty string');

              case 5:
                return _context.abrupt('return', storageAdapter.handleSetStorage(_promise2.default.resolve(this.props), name, value, entityId).then(function (resp) {
                  _this.props.internalDispatcher.emit(entityId.indexOf(APP_TYPE) === 0 ? Events.EVENT_APP_CHANGED : Events.EVENT_ENTITY_CHANGED, entityId, name, value);

                  return resp;
                }));

              case 6:
                if (!(args.length === 2)) {
                  _context.next = 12;
                  break;
                }

                batch = args[0], _entityId = args[1];
                batchError = validateNameValuePairsList(batch);

                if (!(batchError instanceof Error)) {
                  _context.next = 11;
                  break;
                }

                throw batchError;

              case 11:
                return _context.abrupt('return', storageAdapter.handleSetBatchStorage(_promise2.default.resolve(this.props), batch, _entityId).then(function (resp) {
                  _this.props.internalDispatcher.emit(_entityId.indexOf(APP_TYPE) === 0 ? Events.EVENT_APP_CHANGED : Events.EVENT_ENTITY_CHANGED, _entityId, batch);

                  return resp;
                }));

              case 12:
                throw new Error('Bad method call: unknown number of args: ' + args.length);

              case 13:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function setStorage() {
        return _ref2.apply(this, arguments);
      }

      return setStorage;
    }()

    /**
     * Stores a value or a set of values attaching every value to the application. This method supports the following signatures:
     *
     * - Single item mode
     * ```
     *  setAppStorage(name:String, value:*): Promise<*,Error>
     * ```
     *
     * - Batch mode
     * ```
     *  setAppStorage(batch:Array<{name:String, value:*}>): Promise<Array<{name:String, value:*}>,Error>
     * ```
     *
     * See the list of parameters for a description of each one
     *
     * @public
     * @method
     *
     * @param {...*} args
     * @param {string} [args.name] the name under which to store the value
     * @param {string} [args.value] the value to be stored. Will be `JSON serialized`
     * @param {Array<{name:String, value:*}>} [args.batch] a list of name-value pairs for batch processing
     * @return {Promise<Array<{name:String, value:*}>|*,Error>} the list of values which were not saved in batch mode or the saved value in single mode
     */

  }, {
    key: 'setAppStorage',
    value: function () {
      var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var entityId, name, value, batch;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                entityId = APP_TYPE + ':' + this.props.appId;

                if (!(args.length == 2)) {
                  _context2.next = 4;
                  break;
                }

                name = args[0], value = args[1];
                return _context2.abrupt('return', this.setStorage(name, value, entityId));

              case 4:
                if (!(args.length == 1)) {
                  _context2.next = 7;
                  break;
                }

                batch = args[0];
                return _context2.abrupt('return', this.setStorage(batch, entityId));

              case 7:
                throw new Error('Bad method call: unknown number of args: ' + args.length);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function setAppStorage() {
        return _ref3.apply(this, arguments);
      }

      return setAppStorage;
    }()

    /**
     * Stores a value or a set of values attaching every value to the application's context entity. This method supports the following signatures:
     *
     * - Single item mode
     * ```
     *  setEntityStorage(name:String, value:*): Promise<*,Error>
     * ```
     *
     * - Batch mode
     * ```
     *  setEntityStorage(batch:Array<{name:String, value:*}>): Promise<Array<{name:String, value:*}>,Error>
     * ```
     *
     * See the list of parameters for a description of each one
     *
     * @public
     * @method
     *
     * @param {...*} args
     * @param {string} [args.name] the name under which to store the value
     * @param {string} [args.value] the value to be stored. Will be `JSON serialized`
     * @param {Array<{name:String, value:*}>} [args.batch] a list of name-value pairs for batch processing
     * @return {Promise<Array<{name:String, value:*}>|String,Error>} the list of values which were not saved in batch mode or the saved value in single mode
     */

  }, {
    key: 'setEntityStorage',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        var entityId, name, value, batch;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                entityId = this.props.contextEntityType + ':' + this.props.contextEntityId;

                if (!(args.length == 2)) {
                  _context3.next = 4;
                  break;
                }

                name = args[0], value = args[1];
                return _context3.abrupt('return', this.setStorage(name, value, entityId));

              case 4:
                if (!(args.length == 1)) {
                  _context3.next = 7;
                  break;
                }

                batch = args[0];
                return _context3.abrupt('return', this.setStorage(batch, entityId));

              case 7:
                throw new Error('Bad method call: unknown number of args: ' + args.length);

              case 8:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function setEntityStorage() {
        return _ref4.apply(this, arguments);
      }

      return setEntityStorage;
    }()

    /**
     * Retrieves a generic storage item or a list
     *
     * @public
     * @method
     *
     * @param {string|Array<string>} name either one storage item id or a list of ids
     * @param {string} entityId the id of the entity to which the storage item is attached
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise<*|Array<*>, Error>}
     */

  }, {
    key: 'getStorage',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(name, entityId) {
        var _this2 = this;

        var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        var storageAdapter, batch, invalidName;
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                storageAdapter = this.props.storageAdapter;

                if (!validName(name)) {
                  _context4.next = 3;
                  break;
                }

                return _context4.abrupt('return', storageAdapter.handleGetStorage(_promise2.default.resolve(this.props), name, entityId, defaultValue || null).then(function (value) {
                  _this2.props.internalDispatcher.emit(entityId.indexOf(APP_TYPE) === 0 ? Events.EVENT_APP_FETCHED : Events.EVENT_ENTITY_FETCHED, entityId, name, value);

                  return value;
                }));

              case 3:
                batch = name;

                if (!(batch instanceof Array)) {
                  _context4.next = 11;
                  break;
                }

                if (!(batch.length === 0)) {
                  _context4.next = 7;
                  break;
                }

                throw new Error('In batch mode, the first parameter must be a non-empty Array');

              case 7:
                invalidName = batch.filter(function (nameString) {
                  return !validName(nameString);
                });

                if (!invalidName.length) {
                  _context4.next = 10;
                  break;
                }

                throw new Error('Bad method call: some names were not syntactically valid');

              case 10:
                return _context4.abrupt('return', storageAdapter.handleGetBatchStorage(_promise2.default.resolve(this.props), batch, entityId, defaultValue || null).then(function (values) {
                  _this2.props.internalDispatcher.emit(entityId.indexOf(APP_TYPE) === 0 ? Events.EVENT_APP_FETCHED : Events.EVENT_ENTITY_FETCHED, entityId, batch, values);

                  return values;
                }));

              case 11:
                throw new Error('Bad method call');

              case 12:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getStorage(_x, _x2) {
        return _ref5.apply(this, arguments);
      }

      return getStorage;
    }()

    /**
     * Retrieves a storage item attached to the application's context entity
     *
     * @public
     * @method
     *
     * @param {string|Array<string>} name
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise<String|Number|Boolean|Object|null, Error>}
     */

  }, {
    key: 'getEntityStorage',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(name) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var entityId;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                entityId = this.props.contextEntityType + ':' + this.props.contextEntityId;
                return _context5.abrupt('return', this.getStorage(name, entityId, defaultValue));

              case 2:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getEntityStorage(_x4) {
        return _ref6.apply(this, arguments);
      }

      return getEntityStorage;
    }()

    /**
     * Retrieves a storage item attached to the application
     *
     * @public
     * @method
     *
     * @param {string|Array<string>} name
     * @param {*} [defaultValue=null] the value to return if one the the storage items was not found
     * @return {Promise}
     */

  }, {
    key: 'getAppStorage',
    value: function () {
      var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6(name) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var entityId;
        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                entityId = 'app:' + this.props.appId;
                return _context6.abrupt('return', this.getStorage(name, entityId, defaultValue));

              case 2:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getAppStorage(_x6) {
        return _ref7.apply(this, arguments);
      }

      return getAppStorage;
    }()

    /**
     * @deprecated
     * @public
     * @method
     *
     * @param args
     * @return {Promise}
     */

  }, {
    key: 'setAppState',
    value: function () {
      var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7() {
        var _args7 = arguments;
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', this.setAppStorage.apply(this, _args7));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function setAppState() {
        return _ref8.apply(this, arguments);
      }

      return setAppState;
    }()

    /**
     * @deprecated
     * @public
     * @method
     *
     * @return {Promise}
     */

  }, {
    key: 'setEntityState',
    value: function () {
      var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8() {
        var _args8 = arguments;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                return _context8.abrupt('return', this.setEntityStorage.apply(this, _args8));

              case 1:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function setEntityState() {
        return _ref9.apply(this, arguments);
      }

      return setEntityState;
    }()

    /**
     * @ignore
     * @deprecated
     * @public
     * @method
     *
     * @param name
     * @param defaultValue
     * @return {Promise}
     */

  }, {
    key: 'getEntityState',
    value: function () {
      var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(name) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                return _context9.abrupt('return', this.getEntityStorage(name, defaultValue));

              case 1:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getEntityState(_x8) {
        return _ref10.apply(this, arguments);
      }

      return getEntityState;
    }()

    /**
     * @ignore
     * @deprecated
     * @public
     * @method
     *
     * @param name
     * @param defaultValue
     * @return {Promise}
     */

  }, {
    key: 'getAppState',
    value: function () {
      var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(name) {
        var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                return _context10.abrupt('return', this.getAppStorage(name, defaultValue));

              case 1:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function getAppState(_x10) {
        return _ref11.apply(this, arguments);
      }

      return getAppState;
    }()
  }]);
  return StorageApiFacade;
}();

exports.default = StorageApiFacade;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@deskpro/apps-sdk-core/lib/main/javascript/Storage/StorageApiFacade.js
// module id = 312
// module chunks = 0